import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, message, Spin } from 'antd'
import { useSetState } from 'ahooks'
import { getTradeEnums, startAbnormalReturn, verifyOuterData } from '@/services/order'
import dayjs from 'dayjs'
interface IProps {
  title: string
  orderId: string
  open: boolean
  setOpen: (open: boolean) => void
}
export default function SubmitWorkModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
    btnLoading: false,
  })

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        values.orderId = orderId
        // 提交
        startAbnormalReturn(values)
          .then(res => {
            message.success('提交成功')
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }
  const getOptions = async () => {
    return new Promise(async (resolve, reject) => {
      const reasonList = await getTradeEnums('com.shj.saas.plus.trade.enums.AbnormalRefundEnum')
      resolve({
        reasonList:
          reasonList?.map(item => {
            return {
              label: item.description,
              value: item.key,
            }
          }) || [],
      })
    })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <div style={{}}>
              <p>
                提交后将发起审核工单，可在我发起的工单中查看审核进度，审核通过后，该订单商品申请退单退款时违约金不做约束
              </p>
            </div>
            <div>
              <SGeneralForms
                ref={formRef}
                httpOptionsFn={getOptions}
                layout={'vertical'}
                configs={[
                  {
                    formItem: [
                      {
                        spanCol: 24,
                        label: '异常退单类型',
                        name: 'abnormalRefundType',
                        type: 'select',
                        required: true,
                        data: 'reasonList',
                      },
                      {
                        spanCol: 24,
                        label: '申请原因',
                        name: 'reason',
                        type: 'textarea',
                        required: true,
                        comConfig: { showCount: true, maxLength: 200 },
                      },
                    ],
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
